module.exports = __webpack_public_path__ + "static/media/stockhausen_polymorph_11.7fef4ecb.jpg";